/* ============================================================
   BlendWave — Product Page Logic
   Handles color/bundle selection, dynamic pricing, image
   swapping, quantity, sticky buy bar, and cart submission.
   ============================================================ */
(function () {
  const data = window.BlendWaveProduct;
  if (!data) return;

  const variants = data.variants || [];

  const colorGrid = document.getElementById('colorGrid');
  const setOptions = document.getElementById('setOptions');
  const priceDisplay = document.getElementById('priceDisplay');
  const stickyPriceDisplay = document.getElementById('stickyPriceDisplay');
  const selectedColorName = document.getElementById('selectedColorName');
  const selectedSetName = document.getElementById('selectedSetName');
  const variantIdInput = document.getElementById('variantId');
  const quantityInput = document.getElementById('quantityInput');
  const qtyVal = document.getElementById('qtyVal');
  const qtyMinus = document.getElementById('qtyMinus');
  const qtyPlus = document.getElementById('qtyPlus');
  const buyNowBtn = document.getElementById('buyNowBtn');
  const productMainImage = document.getElementById('productMainImage');
  const productGlow = document.getElementById('productGlow');
  const productBlenderWrap = document.getElementById('productBlenderWrap');
  const thumbs = document.querySelectorAll('.thumb');
  const stickyAddToCart = document.getElementById('stickyAddToCart');
  const stickyBuyBar = document.getElementById('stickyBuyBar');
  const productForm = document.getElementById('product-form');
  const productActions = document.querySelector('.product-actions');

  const SET_NAMES = {
    solo: 'BlendWave Solo',
    duo: 'BlendWave Duo',
    set: 'BlendWave + Ice Maker'
  };

  // ── Helpers ────────────────────────────────────────────────
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function findVariant(color, isSet) {
    const option1 = isSet ? color + ' Set' : color;
    return variants.find(function (v) { return v.option1 === option1; });
  }

  function hexToRgba(hex, alpha) {
    if (!hex || hex.charAt(0) !== '#') return 'rgba(0,200,160,' + alpha + ')';
    let h = hex.slice(1);
    if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
    const r = parseInt(h.substring(0, 2), 16);
    const g = parseInt(h.substring(2, 4), 16);
    const b = parseInt(h.substring(4, 6), 16);
    return 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';
  }

  // ── State ──────────────────────────────────────────────────
  const initialColorBtn = colorGrid ? colorGrid.querySelector('.color-btn.active') : null;
  let currentColor = initialColorBtn ? initialColorBtn.dataset.name : (variants[0] ? variants[0].option1.replace(' Set', '') : '');

  const initialSetBtn = setOptions ? setOptions.querySelector('.set-option.active') : null;
  let currentSet = initialSetBtn ? initialSetBtn.dataset.set : 'solo';

  let qty = 1;
  const QTY_MAX = 10;

  // ── Core update routine ────────────────────────────────────
  function update() {
    const soloVariant = findVariant(currentColor, false);
    const setVariant = findVariant(currentColor, true);

    // Update bundle price labels for this color
    const soloPriceEl = setOptions ? setOptions.querySelector('[data-price-solo]') : null;
    const duoPriceEl = setOptions ? setOptions.querySelector('[data-price-duo]') : null;
    const setPriceEl = setOptions ? setOptions.querySelector('[data-price-set]') : null;

    if (soloVariant) {
      if (soloPriceEl) {
        soloPriceEl.textContent = formatMoney(soloVariant.price);
        const soloDiscountEl = soloPriceEl.closest('.set-option-price') ? soloPriceEl.closest('.set-option-price').querySelector('.price-discount-small') : null;
        if (soloDiscountEl) {
          soloDiscountEl.textContent = formatMoney(Math.round(soloVariant.price * 0.75)) + ' with BLENDWAVE';
        }
      }
      if (duoPriceEl) duoPriceEl.textContent = formatMoney(soloVariant.price * 2);
    }
    if (setVariant && setPriceEl) {
      setPriceEl.textContent = formatMoney(setVariant.price);
      const setDiscountEl = setPriceEl.closest('.set-option-price') ? setPriceEl.closest('.set-option-price').querySelector('.price-discount-small') : null;
      if (setDiscountEl) {
        setDiscountEl.textContent = formatMoney(Math.round(setVariant.price * 0.75)) + ' with BLENDWAVE';
      }
    }

    // Determine active variant + unit price + quantity multiplier for this bundle
    let activeVariant = soloVariant;
    let unitPrice = soloVariant ? soloVariant.price : 0;
    let unitMultiplier = 1;

    if (currentSet === 'duo') {
      activeVariant = soloVariant;
      unitPrice = soloVariant ? soloVariant.price * 2 : 0;
      unitMultiplier = 2;
    } else if (currentSet === 'set') {
      activeVariant = setVariant || soloVariant;
      unitPrice = activeVariant ? activeVariant.price : 0;
      unitMultiplier = 1;
    }

    const totalCents = unitPrice * qty;
    const discountCents = Math.round(unitPrice * 0.75); // 25% off

    if (priceDisplay) priceDisplay.textContent = formatMoney(totalCents);
    if (stickyPriceDisplay) stickyPriceDisplay.textContent = formatMoney(totalCents);

    // Update discount price display
    const discountPriceEl = document.querySelector('.price-discount');
    if (discountPriceEl) {
      discountPriceEl.textContent = formatMoney(discountCents) + ' with code BLENDWAVE';
    }

    // Hidden form fields
    if (activeVariant && variantIdInput) variantIdInput.value = activeVariant.id;
    if (quantityInput) quantityInput.value = qty * unitMultiplier;

    // Buy Now link
    if (buyNowBtn && activeVariant) {
      const cartQty = qty * unitMultiplier;
      buyNowBtn.href = data.cartUrl + '/' + activeVariant.id + ':' + cartQty;
    }

    // Add to cart availability
    const available = activeVariant ? activeVariant.available : false;
    const addBtn = productForm ? productForm.querySelector('button[name="add"]') : null;
    if (addBtn) {
      addBtn.disabled = !available;
      const label = available ? 'Add to Cart' : 'Sold Out';
      // Preserve the icon, just swap the trailing text node
      for (let i = addBtn.childNodes.length - 1; i >= 0; i--) {
        const node = addBtn.childNodes[i];
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
          node.textContent = ' ' + label;
          break;
        }
      }
    }
    if (stickyAddToCart) {
      stickyAddToCart.disabled = !available;
      stickyAddToCart.textContent = available ? 'Add to Cart' : 'Sold Out';
    }

    // Image — check for duo/combo images first, then fall back to product image
    let imageSource = null;

    if (currentSet === 'duo' && data.duoImages && data.duoImages[currentColor]) {
      imageSource = data.duoImages[currentColor];
    } else if (currentSet === 'set' && data.comboImages && data.comboImages[currentColor]) {
      imageSource = data.comboImages[currentColor];
    } else {
      // Fall back to variant image
      imageSource = (activeVariant && activeVariant.image) || (soloVariant && soloVariant.image);
    }

    if (imageSource && productMainImage) {
      productMainImage.src = imageSource;
    }

    // Glow color follows selected swatch
    const colorBtn = colorGrid ? colorGrid.querySelector('.color-btn[data-name="' + currentColor + '"]') : null;
    if (colorBtn && productGlow) {
      const swatchColor = colorBtn.dataset.color;
      productGlow.style.background = 'radial-gradient(ellipse at center, ' + hexToRgba(swatchColor, 0.22) + ' 0%, transparent 70%)';
    }
  }

  // ── Color selection ────────────────────────────────────────
  if (colorGrid) {
    colorGrid.addEventListener('click', function (e) {
      const btn = e.target.closest('.color-btn');
      if (!btn) return;

      colorGrid.querySelectorAll('.color-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');

      currentColor = btn.dataset.name;
      if (selectedColorName) selectedColorName.textContent = currentColor;

      update();
    });
  }

  // ── Bundle selection ───────────────────────────────────────
  if (setOptions) {
    setOptions.addEventListener('click', function (e) {
      const btn = e.target.closest('.set-option');
      if (!btn) return;

      setOptions.querySelectorAll('.set-option').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');

      currentSet = btn.dataset.set;
      if (selectedSetName) selectedSetName.textContent = SET_NAMES[currentSet] || btn.dataset.name;

      update();
    });
  }

  // ── Quantity controls ──────────────────────────────────────
  if (qtyMinus) {
    qtyMinus.addEventListener('click', function () {
      if (qty > 1) {
        qty -= 1;
        if (qtyVal) qtyVal.textContent = qty;
        update();
      }
    });
  }
  if (qtyPlus) {
    qtyPlus.addEventListener('click', function () {
      if (qty < QTY_MAX) {
        qty += 1;
        if (qtyVal) qtyVal.textContent = qty;
        update();
      }
    });
  }

  // ── Thumbnails ──────────────────────────────────────────────
  if (thumbs && thumbs.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        const imageSrc = thumb.dataset.image;
        if (imageSrc && productMainImage) productMainImage.src = imageSrc;
      });
    });
  }

  // ── Sticky buy bar ──────────────────────────────────────────
  if (stickyBuyBar && productActions && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyBuyBar.classList.remove('visible');
        } else if (entry.boundingClientRect.top < 0) {
          stickyBuyBar.classList.add('visible');
        } else {
          stickyBuyBar.classList.remove('visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(productActions);
  }

  if (stickyAddToCart) {
    stickyAddToCart.addEventListener('click', function () {
      if (stickyAddToCart.disabled) return;
      if (productForm && typeof productForm.requestSubmit === 'function') {
        productForm.requestSubmit();
      } else if (productForm) {
        productForm.submit();
      }
    });
  }

  // ── Pointer tilt on product image ───────────────────────────
  if (productBlenderWrap && productMainImage) {
    productBlenderWrap.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch') return;
      const rect = productBlenderWrap.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width - 0.5;
      const y = (e.clientY - rect.top) / rect.height - 0.5;
      productMainImage.style.transform = 'rotateY(' + (x * 8) + 'deg) rotateX(' + (y * -8) + 'deg)';
    });
    productBlenderWrap.addEventListener('pointerleave', function () {
      productMainImage.style.transform = '';
    });
  }

  // ── Description dropdown toggle ────────────────────────────────
  const descriptionToggle = document.querySelector('.description-toggle');
  const descriptionContent = document.querySelector('.description-content');
  if (descriptionToggle && descriptionContent) {
    descriptionToggle.addEventListener('click', function () {
      const isExpanded = descriptionToggle.getAttribute('aria-expanded') === 'true';
      descriptionToggle.setAttribute('aria-expanded', !isExpanded);
      descriptionContent.toggleAttribute('hidden');
    });
  }

  // ── Init ─────────────────────────────────────────────────────
  update();
})();
